import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { RmCountPriceListService } from "./rm-count-pricelist-service";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmCountPriceListRequest } from "./dto/rm-count-pricelist.request";
import { RmCountPriceListDto, RmCountPriceListResponseModel, RmRatesInfoReq } from "@gtpl/shared-models/raw-material-procurement";
import { DateFilter } from "@gtpl/shared-models/common-models";
import { IdRequest } from "@gtpl/shared-models/gtpl";

@ApiTags('rm-count-price-list')
@Controller('rm-count-price-list')
export class RmCountPriceListController{
    constructor(
        private rmCountPriceListService:RmCountPriceListService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){ }

    // @Post('/createRmCountPriceList')
    // async createRmCountPriceList(@Body() req:RmCountPriceListDto, @Req() request:Request):Promise<RmCountPriceListResponseModel>{
    //     try{
    //         return await this.rmCountPriceListService.createRmCountPriceList(req,false,request)
    //     }catch(err){
    //       return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel, err);

    //     }
    // }

    // @Post('/getAllRmCountPriceList')
    // async getAllRmCountPriceList(): Promise<AllRmCountPriceListResponse> {
    //     try {
    //         return await this.rmCountPriceListService.getAllRmCountPriceList();
    //     } catch (error) {
    //         return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel, error);
    //     }
    // }

    // @Post('/activateOrDeactivateRmCountPriceList')
    //    async activateOrDeactivateRmCountPriceList(@Body() rmPriceListReq: RmCountPriceListRequest): Promise<RmCountPriceListResponseModel> {
    //        try {
    //            return await this.rmCountPriceListService.activateOrDeactivateRmCountPriceList(rmPriceListReq);
    //        } catch (err) {
    //            return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel, err);
    //        }
    //    }

    //    @Post('/updateRmCountPriceList')
    //    async updateRmCountPriceList(@Body() rmPriceListDTO:RmCountPriceListDto, @Req() request:Request): Promise<RmCountPriceListResponseModel> {
    //        try {
    //         return await this.rmCountPriceListService.createRmCountPriceList(rmPriceListDTO,true,request);
    //       } catch (error) {
    //            return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel, error);
    //       }
    //     }

        @Post('/saveRmCountPricelistInfo')
        async saveRmCountPriceList(@Body() data:any,user:string): Promise<RmCountPriceListResponseModel>{
            console.log(data,"...................");
            
           try{
            return this.rmCountPriceListService.saveRmCountPricelistInfo(data);
           } catch(err){
            return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel,err);
           }
        }

        @Post('/getRmCountPriceListInfo')
        async getRmCountPriceListInfo(@Body() data:RmCountPriceListDto): Promise<RmCountPriceListResponseModel>{
           try{
            return this.rmCountPriceListService.getRmCountPriceListInfo();
           } catch(err){
            return this.applicationExceptionHandler.returnException(RmCountPriceListResponseModel,err);
           }
        }

        @Post('/getRmRatesBmr')
        async getRmRatesBmr(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getRmRatesBmr();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
        @Post('/getRmRatesData')
        async getRmRatesData(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getRmRatesData();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
        @Post('/getRmPriceDeviation')
        async getRmPriceDeviation(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getRmPriceDeviation();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
        @Post('/getRmRatesAqua')
        async getRmRatesAqua(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getRmRatesAqua();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
        @Post('/getRmReportDates')
        async getRmReportDates(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getRmReportDates();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
        @Post('/getCompanies')
        async getCompanies(): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getCompanies();
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

   @Post('/getRmRatesAgainstUploadedDate')
   async getRmRatesAgainstUploadedDate(@Body() req:RmRatesInfoReq): Promise<CommonResponse>{
      try{
      return this.rmCountPriceListService.getRmRatesAgainstUploadedDate(req);
      } catch(err){
      return this.applicationExceptionHandler.returnException(CommonResponse,err);
      }
   }

   @Post('/getHalfCountRangesInfo')
   async getHalfCountRangesInfo(): Promise<CommonResponse>{
      try{
      return this.rmCountPriceListService.getHalfCountRangesInfo();
      } catch(err){
      return this.applicationExceptionHandler.returnException(CommonResponse,err);
      }
   }
   
   @Post('/getMaxEffectiveDate')
async getMaxEffectiveDate(@Body() req:RmRatesInfoReq): Promise<CommonResponse>{
   try{
   return this.rmCountPriceListService.getMaxEffectiveDate(req);
   } catch(err){
   return this.applicationExceptionHandler.returnException(CommonResponse,err);
   }
}
@Post('/createProductCount')
        async createProductCount(@Body() data:any,user:string): Promise<CommonResponse>{
            console.log(data,"...................");
            
           try{
            return this.rmCountPriceListService.createProductCount(data);
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/updateProductCount')
        async updateProductCount(@Body() data:any): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.updateProductCount(data);
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/getAllProductCount')
        async getAllProductCount(@Body() req?:any): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getAllProductCount(req);
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }

        @Post('/getProductCountById')
        async getProductCountById(@Body() data:any): Promise<CommonResponse>{
           try{
            return this.rmCountPriceListService.getProductCountById(data);
           } catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err);
           }
        }
}